const Dashboard = () => {
  return (
    <div>dashboard</div>
  )
}

export default Dashboard